module.exports = __webpack_public_path__ + "img/title5.91a04aa8.png";